import { FC } from 'react';
import { Route, Switch } from 'react-router-dom';
import { PrivateRoute } from 'routes';
import LoggedOutOnlyRoute from 'routes/LoggedOutOnlyRoute';
import PageNotFound from 'views/PageNotFound';
import { CommonRouteConfig } from 'routes/CommonRoutes';

type Props = {
  routes: Array<CommonRouteConfig>;
  user?: {
    isAuthenticated?: boolean;
  };
};

const RouteRenderer: FC<Props> = ({ routes, user }) => {
  return (
    <Switch>
      {routes.map((route, idx) =>
        route?.private ? (
          <PrivateRoute
            key={idx}
            path={route?.path}
            exact={route?.exact}
            component={route?.component}
            user={user}
            redirectToSignUp={route?.redirectToSignUp}
          />
        ) : route.isLoggedOutOnlyRoute ? (
          <LoggedOutOnlyRoute
            key={idx}
            path={route?.path}
            exact={route?.exact}
            component={route?.component}
            user={user}
          />
        ) : (
          <Route
            key={idx}
            path={route?.path}
            exact={route?.exact}
            component={route?.component}
          />
        ),
      )}
      <Route key={'404'} path={'*'} exact component={PageNotFound} />
    </Switch>
  );
};

export default RouteRenderer;
